
import React from 'react';
import EmptyProductsList from './EmptyProductsList';
import ProductsTable from './ProductsTable';

interface Product {
  id: string;
  name: string;
  price: number;
  quantity: number;
  total: number;
}

interface OrderProductsListProps {
  products: Product[];
  onRemoveProduct: (productId: string) => void;
}

const OrderProductsList = ({ products, onRemoveProduct }: OrderProductsListProps) => {
  if (products.length === 0) {
    return <EmptyProductsList />;
  }

  return (
    <div className="overflow-x-auto">
      <ProductsTable products={products} onRemoveProduct={onRemoveProduct} />
    </div>
  );
};

export default OrderProductsList;
